import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/price_lists',
    name: 'PriceList',
    component: {
      name: 'AdminPriceList',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'price_list',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPriceListIndex',
        component: () => import('../views/priceList/PriceListIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPriceListNew',
        component: () => import('../views/priceList/PriceListInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPriceListIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPriceListShow',
        component: () => import('../views/priceList/PriceListShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPriceListIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPriceListDetails',
            component: () => import('../views/priceList/PriceListDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPriceListIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPriceListEdit',
            component: () => import('../views/priceList/PriceListInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPriceListDetails' },
            },
          },
          {
            path: 'price_agreements',
            name: 'AdminPriceAgreements',
            component: {
              name: 'AdminPriceAgreement',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminPriceListIndex' },
              resource: 'price_agreement',
            },
            children: [
              {
                path: '',
                name: 'AdminPriceListPriceAgreements',
                component: () => import('../views/priceAgreement/PriceAgreementsIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminPriceListIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminPriceAgreementNew',
                component: () => import('../views/priceAgreement/PriceAgreementInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminPriceListPriceAgreements' },
                },
              },
              {
                path: ':priceAgreementId(\\d+)',
                name: 'AdminPriceAgreementShow',
                component: () => import('../views/priceAgreement/PriceAgreementShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminPriceListPriceAgreements',
                  },
                  tArgs: route => ({ name: route.params?.priceAgreementId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminPriceAgreementDetails',
                    component: () => import('../views/priceAgreement/PriceAgreementDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminPriceListPriceAgreements' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminPriceAgreementEdit',
                    component: () => import('../views/priceAgreement/PriceAgreementInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminPriceAgreementDetails' },
                    },
                  },
                ]
              }
            ],
          },
          /* ------- PRICE LIST ENTRIES TAB ------- */
          {
            path: 'price_list_entries',
            name: 'AdminPriceListEntries',
            component: {
              name: 'AdminPriceListEntry',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminPriceListIndex' },
              resource: 'price_list_entry',
            },
            children: [
              {
                path: '',
                name: 'AdminPriceListPriceListEntries',
                component: () => import('../views/priceListEntry/PriceListEntriesIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminPriceListIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminPriceListEntryNew',
                component: () => import('../views/priceListEntry/PriceListEntryInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminPriceListPriceListEntries' },
                },
              },
              {
                path: ':priceListEntryId(\\d+)',
                name: 'AdminPriceListEntryShow',
                component: () => import('../views/priceListEntry/PriceListEntryShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminPriceListPriceListEntries',
                  },
                  tArgs: route => ({ name: route.params?.priceListEntryId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminPriceListEntryDetails',
                    component: () => import('../views/priceListEntry/PriceListEntryDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminPriceListPriceListEntries' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminPriceListEntryEdit',
                    component: () => import('../views/priceListEntry/PriceListEntryInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminPriceListEntryDetails' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));